import { APIS, APPGUID, ENVIRONMENT_MODE } from "../utils/constants/SYSTEM";
import axios from "../utils/helpers/axios";
import ax from "axios";

const api = {
  checkEmailExists: async (email, userName) => {
    try {
      const res = await axios().post(`/AdminUser/ForgotPasswordCheckEmail`, {
        AppGUID: APPGUID,
        userName,
        emailAddress: email,
      });

      return !res.data.errorMessage;
    } catch (error) {
      return false;
    }
  },

  forgotPasswordTicketSubmit: async (email, userName) => {
    try {
      const resp = await axios().post("/AdminUser/ForgotPasswordSendEmail", {
        userName,
        AppGUID: APPGUID,
        emailAddress: email,
      });

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getQrCode: async () => {
    try {
      const resp = await axios().get(
        "/OTP/GetQrCode?appName=Deal%20Portal&accountName=Admin"
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  verifyToken: async (token) => {
    try {
      // TODO: Use relative path once code is merged on AdminAPI
      const resp = await axios().post(`/OTP/VerifyToken?token=${token}`);

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  searchMMCode: async (mmCode, newDemoUsed) => {
    try {
      const resp = await axios().get(
        `/DealPortal/SearchMMCode?mmCode=${mmCode}&newDemoUsed=${newDemoUsed}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  searchVIN: async (vin) => {
    try {
      const resp = await axios().get(`/DealPortal/SearchVIN?vin=${vin}`);

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  searchKeywordNew: async (query) => {
    try {
      const resp = await axios().get(
        `/DealPortal/SearchKeywordNew?${query}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  searchKeywordUsed: async (keyword) => {
    try {
      const resp = await axios().get(
        `/DealPortal/SearchKeywordUsed?keyword=${keyword}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  searchDateRangeNew: async (startDate, endDate, includeInactive) => {
    try {
      const resp = await axios().get(
        `/DealPortal/SearchDateRangeNew?startDate=${startDate}&endDate=${endDate}&includeInactive=${includeInactive}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  searchDateRangeUsed: async (startDate, endDate) => {
    try {
      const resp = await axios().get(
        `/DealPortal/SearchDateRangeUsed?startDate=${startDate}&endDate=${endDate}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getBrands: async (isInternal) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetBrands?isInternal=${isInternal}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getRanges: async (brandID, newDemoUsed) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetRanges?brandID=${brandID}&newDemoUsed=${newDemoUsed}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getModels: async (rangeID, newDemoUsed) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetModels?rangeID=${rangeID}&newDemoUsed=${newDemoUsed}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getDealsByBrandID: async (brandIDs, includeInactive, includeElapsed = false) => {
    try {
      const promises = brandIDs
        .filter((b) => b.selected)
        .map(
          async (b) =>
            await axios().get(
              `/DealPortal/GetDealsByBrandID?brandID=${b.brandID}&includeInactive=${includeInactive}&includeElapsed=${includeElapsed}`
            )
        );
      const resp = await Promise.all(promises);
      return resp.map((p) => p.data);
    } catch (error) {
      throw Error(error);
    }
  },

  getAllActiveUsedDeals: async (includeInactive) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetAllActiveUsedDeals?includeInactive=${true}`
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getNewSchemeDealInfo: async (dealID) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetNewSchemeDealInfo?preloadedDealsID=${dealID}`
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getNewListPriceDealInfo: async (dealID) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetNewListPriceDealInfo?preloadedDealsID=${dealID}`
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getUsedDealInfo: async (dealID) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetUsedDealInfo?usedCarID=${dealID}`
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getUsedDealImages: async (usedCarID) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetUsedDealImages?usedCarID=${usedCarID}`
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  insertNewSchemeDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/InsertNewSchemeDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  insertNewListPriceDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/InsertNewListPriceDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updateNewSchemeDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/UpdateNewSchemeDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updateNewListPriceDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/UpdateNewListPriceDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  insertCDPUsedDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/InsertCDPUsedDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  insertPLDUsedDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/InsertPLDUsedDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updateCDPUsedDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/UpdateCDPUsedDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updatePLDUsedDeal: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/UpdatePLDUsedDeal`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updateZohoRecord: async (payload) => {
    /*
    public string Module { get; set; }
    // Make sure the record's ID is in the Json object. {id: "1234567890123456", field_to_update: "value"}
    public string Json { get; set; }
    */
    try {
      const resp = await axios().post(`/Zoho/UpdateRecord`, payload);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  runCOQLQuery: async (query) => {
    // public string Query { get; set; }
    try {
      const resp = await axios().post(`/Zoho/COQL`, {Query: query});
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getStockLocations: async () => {
    try {
      const resp = await axios().get(`/DealPortal/GetStockLocations`);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updatePreloadedNewDealEndDate: async (deal) => {
    try {
      const resp = await axios().post(
        `/DealPortal/UpdatePreloadedNewDealEndDate`,
        deal
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updatePreloadedUsedDealEndDate: async (deal) => {
    try {
      const resp = await axios().post(
        `/DealPortal/UpdatePreloadedUsedDealEndDate`,
        deal
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updatePreloadedNewDealDealStatus: async (deal) => {
    try {
      const resp = await axios().post(
        `/DealPortal/UpdatePreloadedNewDealDealStatus`,
        deal
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updatePreloadedUsedDealDealStatus: async (deal) => {
    try {
      const resp = await axios().post(
        `/DealPortal/UpdatePreloadedUsedDealDealStatus`,
        deal
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  updateTurnDealOnOrOff: async (data) => {
    try {
      const resp = await axios().post(
        `/DealPortal/UpdateTurnDealOnOrOff`,
        data
      );
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getCarDataPubResultFromMMCode: async (mmCode) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetCarDataPubResultFromMMCode?mmCode=${mmCode}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getDealByModelIDAndType: async (modelID, dealType, deposit, period) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetDealByModelIDAndType?modelID=${modelID}&dealType=${dealType}&deposit=${deposit}&period=${period}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getCarDataPubUsedDealByModelID: async (modelID) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetCarDataPubUsedDealByModelID?modelID=${modelID}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getPreloadedUsedDealByUsedCarID: async (usedCarID) => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetPreloadedUsedDealByUsedCarID?usedCarID=${usedCarID}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  insertUsedDealImages: async (dealImagesInput) => {
    try {
      const resp = await axios().post(
        `/DealPortal/InsertUsedDealImages`,
        dealImagesInput
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  upsertUsedDealImages: async (dealImagesInput) => {
    try {
      const resp = await axios().post(
        `/DealPortal/UpsertUsedDealImages`,
        dealImagesInput
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  deleteUsedDealImage: async (imageID) => {
    try {
      const resp = await axios().post(
        `/DealPortal/DeleteUsedDealImage?imageID=${imageID}`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  getVAT: async () => {
    try {
      const baseURL = APIS["WIDGET"]["DEVELOPMENT"];
      const param = "/Admin/GetVat";
      const resp = await fetch(baseURL + param);

      return resp.json();
    } catch (error) {
      throw Error(error);
    }
  },

  getDealershipFees: async () => {
    try {
      const resp = await axios().get(
        `/DealPortal/GetDealershipFees`
      );

      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },

  sendEmail: async (data) => {
    try {
      const resp = await axios(APIS.WIDGET[ENVIRONMENT_MODE]).post(`/Misc/SaveEmailToBeSent`, data);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  checkSchemeDealsForIssues: async (userEmail, fileName, schemeDeals) => {
    try {
      const resp = await axios().post(`/DealPortal/CheckSchemeDeals?userEmail=${userEmail}&fileName=${fileName}`, schemeDeals);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  checkListPriceDealsForIssues: async (userEmail, fileName, listPriceDeals) => {
    try {
      const resp = await axios().post(`/DealPortal/CheckListPriceDeals?userEmail=${userEmail}&fileName=${fileName}`, listPriceDeals);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  getDealAudit: async (preloadedDealID) => {
    try {
      const resp = await axios().get(`/DealPortal/GetDealAudit?PreloadedDealID=${preloadedDealID}`);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  insertDealAudit: async (data) => {
    try {
      const resp = await axios().post(`/DealPortal/InsertDealAudit`, data);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  getExcelFileHistory: async () => {
    try {
      const resp = await axios().get(`/DealPortal/GetDealPortalFiles`);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  insertExcelFileHistory: async (data) => {
    try {
      const resp = await axios().post(`/DealPortal/DealPortalFileUpload`, data);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  getAutoTraderListings: async () => {
    try {
      const resp = await axios().get(`/DealPortal/GetAutoTraderListings`);
      return resp.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  updateElasticSearchPrice: async (deal) => {
    try {
      const resp = await axios().post(`/DealPortal/UpdateElasticSearchPrice`, deal);
      return resp.data;
    } catch (error) {
      throw Error(error);
    }
  },
};

export default api;